import QuantityInput from 'containers/QuantityInput';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { TrackingAddToCartAddFromType, Uom } from 'types/schema';
import { allowDecimalQuantity } from 'utils/allowDecimalQuantity';
import formatMoney from 'utils/formatMoney';
import utilMessages from 'utils/messages';
import { componentPermissions } from '../Product';
import { EventName, sendGA4Event } from 'utils/triggerGA4Event';

const AddToCartBottomBarContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 0 16px;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 1000;
  background: #fcfffc;
  width: 100%;
  height: 70px;
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.25);

  @media (min-width: 1024px) {
    display: none;
  }
`;

const AddToCartBottomBarTotalPriceContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
const AddToCartBottomBarTotalPriceValue = styled.span`
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  color: #43a047;
  letter-spacing: -0.16px;
`;
const AddToCartBottomBarTotalPriceSubDesc = styled.span`
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: #757d73;
`;

const ExclusiveNoteText = styled.div`
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: -0.14px;
  font-style: normal;
  color: #596056;
  margin-bottom: 8px;
`;

const OutOfStockButton = styled.div`
  width: 100%;
  padding: 12px 16px;
  border-radius: 8px;
  background: #f5f5f4;
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  color: #bcbfbb;
  text-align: center;
`;

interface AddToCartBottomBarProps {
  loggedIn?: boolean;
  permissions?: string[];
  loading?: boolean;
  allowAddToCart?: boolean;
  allowPurchase?: boolean;
  totalPrice?: number;
  product?: any;
  uom?: Uom;
  setCurrentQuantity: (value: string) => void;
}
const AddToCartBottomBar = (props: AddToCartBottomBarProps) => {
  const {
    loggedIn = false,
    permissions = [],
    loading = false,
    allowAddToCart = false,
    allowPurchase = false,
    totalPrice = 0,
    product,
    uom,
    setCurrentQuantity,
  } = props;
  return (
    <AddToCartBottomBarContainer>
      {(!loggedIn || permissions.includes(componentPermissions.addToCartPermission)) &&
        !loading &&
        (allowAddToCart ? (
          <>
            <AddToCartBottomBarTotalPriceContainer>
              <AddToCartBottomBarTotalPriceValue>{formatMoney(totalPrice)}đ</AddToCartBottomBarTotalPriceValue>
              <AddToCartBottomBarTotalPriceSubDesc>
                <FormattedMessage {...utilMessages.beforeVat} />
              </AddToCartBottomBarTotalPriceSubDesc>
            </AddToCartBottomBarTotalPriceContainer>
            <div
              style={{
                width: '50%',
              }}
            >
              <QuantityInput
                product={product}
                allowDecimal={allowDecimalQuantity(uom)}
                addFrom={TrackingAddToCartAddFromType.ProductDetail}
                onFinalChangeQuantityValue={(value) => {
                  setCurrentQuantity(value);
                }}
                ga4Callback={(value) => {
                  sendGA4Event(EventName.PDP_ADD_TO_CART, {
                    product_id: product.id,
                    product_name: product.name,
                    quantity: value,
                    source: 'pdp',
                  });
                }}
                isProductDetails={true}
              />
            </div>
          </>
        ) : !allowPurchase ? (
          <>
            <ExclusiveNoteText>
              <FormattedMessage {...utilMessages.onlyForSpecialBusiness} />
            </ExclusiveNoteText>
            <OutOfStockButton>
              <FormattedMessage {...utilMessages.exclusive} />
            </OutOfStockButton>
          </>
        ) : (
          <OutOfStockButton>
            <FormattedMessage {...utilMessages.outStock} />
          </OutOfStockButton>
        ))}
    </AddToCartBottomBarContainer>
  );
};

export default AddToCartBottomBar;
